import { cn } from "@/lib/utils";

const map = {
  approved: "bg-[hsl(var(--success))]/10 text-[hsl(var(--success))] border-[hsl(var(--success))]/20",
  pending: "bg-[hsl(var(--warning))]/10 text-[hsl(var(--warning))] border-[hsl(var(--warning))]/20",
  rejected: "bg-[hsl(var(--danger))]/10 text-[hsl(var(--danger))] border-[hsl(var(--danger))]/20",
  new: "bg-primary/10 text-primary border-primary/20",
  existing: "bg-muted text-foreground border-border",
  active: "bg-[hsl(var(--success))]/10 text-[hsl(var(--success))] border-[hsl(var(--success))]/20",
  inactive: "bg-muted text-muted-foreground border-border",
};

export function StatusPill({ status, children, className, testid }) {
  const cls = map[status] || "bg-muted text-foreground border-border";
  return (
    <span
      data-testid={testid}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium capitalize",
        cls,
        className,
      )}
    >
      {children || status}
    </span>
  );
}
